import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Form, FormLayout, Card, Button, Select, ChoiceList, DropZone, TextStyle, Caption, Icon, Heading, Checkbox, Label, DisplayText } from '@shopify/polaris';
import { NoteMajorMonotone } from '@shopify/polaris-icons';

import { tAttribute } from '@utils';
import { BasicTextField } from '@presentational';
import FormPageActions from '@container/FormPageActions';

import { formikFormProps, selectOptionsProp } from 'utils/shapeProps';

const propTypes = {
  ...formikFormProps,

  salespoints: selectOptionsProp.isRequired,
}

const defaultProps = {

}

const SellerApplicationForm = (props) => {
  const [catalog, setCatalog] = useState(); 
  const [selectedSalespoints, setSelectedSalespoints] = useState([]);
  const sharedFieldProps = { handleChange: props.handleChange, values: props.values, errors: props.errors, handleBlur: props.handleBlur, touched: props.touched };

  const handleSalespointsChange = useCallback( (value) => {
    if(props.values.salespoints_other && !value.includes("other")){ // clear salespoints_other value when removing "other" option
      props.setFieldValue("salespoints_other", "");
    }
    setSelectedSalespoints(value);
    props.setFieldValue("salespoints", value);
  }, [props.values.salespoints_other])

  const handleDropZoneDrop = useCallback( (_dropFiles, acceptedFiles, _rejectedFiles) => {
    setCatalog(acceptedFiles[0]),
    props.setFieldValue("catalog", acceptedFiles[0]);
  }, [] );

  const fileUpload = !catalog && <DropZone.FileUpload />;

  const uploadedFile = catalog && (
    <div className="flex justifyStart m10">
      <Icon
        source={NoteMajorMonotone}
      />
      <div className="flexContainer ml8">
        <Heading>
          { catalog.name }
        </Heading>
      </div>
    </div>
  )
  
  const choices = [...props.salespoints, { value: "other", label: "Otro" } ]

  useEffect( () => {
    console.group("CC");
      console.log(props.values);
      console.log("Values", props.values.salespoints);
      console.log("Local selection", selectedSalespoints);
    console.groupEnd();
    if(props.values.salespoints.length == 0 && selectedSalespoints.length > 0 ){
      console.log("Clear")
      setSelectedSalespoints([]);
      setCatalog(null);
    }
  }, [props.values.salespoints] )

  return(
    <Form onSubmit={ props.handleSubmit }>
     
        <Card>
          <Card.Section title={ I18n.t("app.seller_application_form.sections.contact") }>
            <FormLayout>
              <FormLayout.Group>
                <BasicTextField name="first_name" placeholder={ tAttribute("general", "first_name") } label={ tAttribute("general", "first_name") } {...sharedFieldProps} />
                <BasicTextField name="last_name"  placeholder={ tAttribute("general", "last_name") } label={ tAttribute("general", "last_name") } {...sharedFieldProps} />
              </FormLayout.Group>

              <FormLayout.Group>
                <BasicTextField name="email" placeholder={ tAttribute("general", "email") } label={ tAttribute("general", "email") } {...sharedFieldProps} />
                <BasicTextField name="phone" placeholder={ tAttribute("general", "phone") } label={ tAttribute("general", "phone") } {...sharedFieldProps} />
              </FormLayout.Group>
            </FormLayout>
          </Card.Section>

          <Card.Section title={ I18n.t("app.seller_application_form.sections.company") }>
            <FormLayout>
              <FormLayout.Group>
                <BasicTextField name="company_name" placeholder={ tAttribute("seller_application_form", "company_name") } label={ tAttribute("seller_application_form", "company_name") } {...sharedFieldProps} />
                <BasicTextField name="legal_id"     placeholder={ tAttribute("seller_application_form", "legal_id") }  label={ tAttribute("seller_application_form", "legal_id") } {...sharedFieldProps} />
              </FormLayout.Group>

              <BasicTextField name="address" placeholder={tAttribute("general", "address")} label={ tAttribute("general", "address") } multiline={2} {...sharedFieldProps} />
            </FormLayout>
          </Card.Section>
      
          <Card.Section title={ I18n.t("app.seller_application_form.sections.commerce") }>
            <FormLayout>
              <BasicTextField name="commerce_information" placeholder={ tAttribute("seller_application_form", "commerce_information") } label={ tAttribute("seller_application_form", "commerce_information") } {...sharedFieldProps} />
              <BasicTextField name="website" placeholder="http://www.ejemplo.com" label={ tAttribute("seller_application_form", "website") } {...sharedFieldProps} />

              <div className="flex justifyCenter">
                <DisplayText size="small"><i>- o -</i></DisplayText>
              </div>

              <div>
                <div className="mb5">
                  <Label>
                    { tAttribute("seller_application_form", "catalog") }
                  </Label>
                </div>
                
                <DropZone
                  accept="application/pdf, image/jpeg, image/png, .csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.oasis.opendocument.spreadsheet"
                  allowMultiple={false} onDrop={handleDropZoneDrop}>
                  { uploadedFile }
                  {fileUpload}
                </DropZone>
              </div>  

              {/* <Select
                id="currency"
                name="currency"
                label={ tAttribute("general", "currency") }
                options={ props.currencies }
                value={ props.values.currency }
                onChange={ props.handleChange }
                error={ props.errors.currency }
              /> */}

              <ChoiceList
                allowMultiple
                title="¿Adónde vendés tus productos actualmente?"
                choices={ choices }
                selected={ selectedSalespoints }
                onChange={handleSalespointsChange}
                error={ props.errors.salespoints }
              />

              { selectedSalespoints.includes("other") &&
                <BasicTextField name="salespoints_other" label="Especifique" placeholder="" {...sharedFieldProps} />
              }
            </FormLayout>
          </Card.Section>

          <Card.Section>
            <div className="flex justifyCenter">
              <Button disabled={ !props.isValid } loading={ props.loading } primary onClick={ props.handleSubmit }>APLICAR</Button>
            </div>
          </Card.Section>
        </Card>
    </Form>
  )
}

SellerApplicationForm.propTypes = propTypes;
SellerApplicationForm.defaultProps = defaultProps;

export default SellerApplicationForm;